// API Configuration
const useSpeechProxy = process.env.REACT_APP_SPEECH_PROXY === '1';

const API_CONFIG = {
  // Firebase Functions base URL
  FIREBASE_FUNCTIONS_URL: useSpeechProxy
    ? ''
    : (process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || (
        process.env.NODE_ENV === 'production' 
          ? 'https://speechtotext-xa6dlzc3uq-uc.a.run.app'
          : 'http://localhost:5002/beautyfinancetracker/us-central1'
      )),
  
  // API endpoints
  ENDPOINTS: {
    SPEECH_TO_TEXT: useSpeechProxy ? '/__speech' : '', // Direct URL, no path needed
    SPEECH_HEALTH_CHECK: useSpeechProxy ? '/__speechHealth' : 'https://speechhealthcheck-xa6dlzc3uq-uc.a.run.app',
    SCAN_RECEIPT: '/scanReceiptHttp',
    CORS_TEST: '/corsTest'
  }
};

export default API_CONFIG;
